import transformer from '../../../common/transformers/response-raw';

export default transformer;
